module.exports = __webpack_public_path__ + "static/thumb-fc103868a3b521ad599de44241128dbb.png";